// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Users page — "Actions" dropdown (report / export with audience choice) */

.users-actions {
  --users-actions-hover: color-mix(in srgb, var(--text-primary) 6%, transparent);
  position: relative;
  margin-left: auto;
  flex-shrink: 0;
}

.users-actions-trigger {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 12px 0 14px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font: inherit;
  font-size: 0.875rem;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;
}

.users-actions-trigger:hover {
  background: var(--users-actions-hover);
}

.users-actions-trigger.is-open,
.users-actions-trigger:focus-visible {
  outline: none;
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent-primary) 15%, transparent);
}

.users-actions-trigger .custom-icon {
  color: var(--text-secondary);
}

.users-actions-trigger-chevron {
  transition: transform 0.18s ease;
}

.users-actions-trigger.is-open .users-actions-trigger-chevron {
  transform: rotate(180deg);
}

.users-actions-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 1000;
  width: 320px;
  max-width: calc(100vw - 32px);
  padding: 6px;
  border: 1px solid var(--border-color);
  border-radius: 14px;
  background: var(--bg-primary);
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12), 0 2px 6px rgba(15, 23, 42, 0.06);
  transform-origin: top right;
  overflow: hidden;
}

.users-actions-divider {
  height: 1px;
  margin: 4px 8px;
  background: var(--border-color);
}

.users-actions-item,
.users-actions-audience {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--text-primary);
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.12s ease;
}

.users-actions-item:hover,
.users-actions-item:focus-visible,
.users-actions-audience:hover:not(:disabled),
.users-actions-audience:focus-visible {
  outline: none;
  background: var(--users-actions-hover);
}

.users-actions-item-icon,
.users-actions-audience-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: var(--bg-tertiary);
  color: var(--text-secondary);
}

.users-actions-item-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1;
  min-width: 0;
}

.users-actions-item-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.3;
}

.users-actions-item-hint {
  font-size: 0.75rem;
  line-height: 1.35;
  color: var(--text-secondary);
}

.users-actions-item-chevron {
  flex-shrink: 0;
  color: var(--text-secondary);
  opacity: 0.6;
  transition: transform 0.15s ease, opacity 0.15s ease;
}

.users-actions-item:hover .users-actions-item-chevron {
  opacity: 1;
  transform: translateX(2px);
}

.users-actions-badge {
  padding: 1px 7px;
  border-radius: 999px;
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: var(--accent-primary);
  background: color-mix(in srgb, var(--accent-primary) 12%, transparent);
}

/* Audience panel */

.users-actions-panel-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 4px 8px;
  margin-bottom: 4px;
  border-bottom: 1px solid var(--border-color);
}

.users-actions-back {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  transition: background-color 0.12s ease, color 0.12s ease;
}

.users-actions-back:hover:not(:disabled) {
  background: var(--users-actions-hover);
  color: var(--text-primary);
}

.users-actions-back:disabled {
  opacity: 0.4;
  cursor: default;
}

.users-actions-panel-titles {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.users-actions-panel-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-primary);
}

.users-actions-panel-subtitle {
  font-size: 0.75rem;
  color: var(--text-secondary);
}

.users-actions-audiences {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.users-actions-audience:disabled {
  cursor: default;
}

.users-actions-audience:disabled:not(.is-busy) {
  opacity: 0.5;
}

.users-actions-audience.is-accent .users-actions-audience-icon {
  color: #059669;
  background: rgba(16, 185, 129, 0.12);
}

.users-actions-count {
  flex-shrink: 0;
  min-width: 36px;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  font-size: 0.75rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  text-align: center;
}

.users-actions-count-skeleton {
  display: inline-block;
  width: 24px;
  height: 8px;
  border-radius: 4px;
  background: currentColor;
  opacity: 0.25;
  animation: users-actions-pulse 1s ease-in-out infinite;
}

.users-actions-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: users-actions-spin 0.7s linear infinite;
}

@keyframes users-actions-spin {
  to { transform: rotate(360deg); }
}

@keyframes users-actions-pulse {
  50% { opacity: 0.1; }
}

:root[data-theme='dark'] .users-actions-dropdown {
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.45), 0 2px 6px rgba(0, 0, 0, 0.3);
}

:root[data-theme='dark'] .users-actions-audience.is-accent .users-actions-audience-icon {
  color: #34d399;
  background: rgba(52, 211, 153, 0.14);
}

@media (max-width: 640px) {
  .users-actions-dropdown {
    width: 290px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/users-actions-menu.css"],"names":[],"mappings":"AAAA,2EAA2E;;AAE3E;EACE,8EAA8E;EAC9E,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,4CAA4C;EAC5C,uFAAuF;AACzF;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,aAAa;EACb,mCAAmC;EACnC,gFAAgF;AAClF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B,gFAAgF;EAChF,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,+BAA+B;AACjC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;;;;EAIE,aAAa;EACb,sCAAsC;AACxC;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,YAAY;EACZ,oDAAoD;AACtD;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,sEAAsE;AACxE;;AAEA,mBAAmB;;AAEnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,sDAAsD;AACxD;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":["/* Users page — \"Actions\" dropdown (report / export with audience choice) */\n\n.users-actions {\n  --users-actions-hover: color-mix(in srgb, var(--text-primary) 6%, transparent);\n  position: relative;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\n.users-actions-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 38px;\n  padding: 0 12px 0 14px;\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font: inherit;\n  font-size: 0.875rem;\n  font-weight: 500;\n  white-space: nowrap;\n  cursor: pointer;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.users-actions-trigger:hover {\n  background: var(--users-actions-hover);\n}\n\n.users-actions-trigger.is-open,\n.users-actions-trigger:focus-visible {\n  outline: none;\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent-primary) 15%, transparent);\n}\n\n.users-actions-trigger .custom-icon {\n  color: var(--text-secondary);\n}\n\n.users-actions-trigger-chevron {\n  transition: transform 0.18s ease;\n}\n\n.users-actions-trigger.is-open .users-actions-trigger-chevron {\n  transform: rotate(180deg);\n}\n\n.users-actions-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  z-index: 1000;\n  width: 320px;\n  max-width: calc(100vw - 32px);\n  padding: 6px;\n  border: 1px solid var(--border-color);\n  border-radius: 14px;\n  background: var(--bg-primary);\n  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12), 0 2px 6px rgba(15, 23, 42, 0.06);\n  transform-origin: top right;\n  overflow: hidden;\n}\n\n.users-actions-divider {\n  height: 1px;\n  margin: 4px 8px;\n  background: var(--border-color);\n}\n\n.users-actions-item,\n.users-actions-audience {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 10px;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--text-primary);\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 0.12s ease;\n}\n\n.users-actions-item:hover,\n.users-actions-item:focus-visible,\n.users-actions-audience:hover:not(:disabled),\n.users-actions-audience:focus-visible {\n  outline: none;\n  background: var(--users-actions-hover);\n}\n\n.users-actions-item-icon,\n.users-actions-audience-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 32px;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n}\n\n.users-actions-item-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1;\n  min-width: 0;\n}\n\n.users-actions-item-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  line-height: 1.3;\n}\n\n.users-actions-item-hint {\n  font-size: 0.75rem;\n  line-height: 1.35;\n  color: var(--text-secondary);\n}\n\n.users-actions-item-chevron {\n  flex-shrink: 0;\n  color: var(--text-secondary);\n  opacity: 0.6;\n  transition: transform 0.15s ease, opacity 0.15s ease;\n}\n\n.users-actions-item:hover .users-actions-item-chevron {\n  opacity: 1;\n  transform: translateX(2px);\n}\n\n.users-actions-badge {\n  padding: 1px 7px;\n  border-radius: 999px;\n  font-size: 0.6875rem;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  color: var(--accent-primary);\n  background: color-mix(in srgb, var(--accent-primary) 12%, transparent);\n}\n\n/* Audience panel */\n\n.users-actions-panel-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 4px 8px;\n  margin-bottom: 4px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.users-actions-back {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: background-color 0.12s ease, color 0.12s ease;\n}\n\n.users-actions-back:hover:not(:disabled) {\n  background: var(--users-actions-hover);\n  color: var(--text-primary);\n}\n\n.users-actions-back:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n.users-actions-panel-titles {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.users-actions-panel-title {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.users-actions-panel-subtitle {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n}\n\n.users-actions-audiences {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.users-actions-audience:disabled {\n  cursor: default;\n}\n\n.users-actions-audience:disabled:not(.is-busy) {\n  opacity: 0.5;\n}\n\n.users-actions-audience.is-accent .users-actions-audience-icon {\n  color: #059669;\n  background: rgba(16, 185, 129, 0.12);\n}\n\n.users-actions-count {\n  flex-shrink: 0;\n  min-width: 36px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  font-size: 0.75rem;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  text-align: center;\n}\n\n.users-actions-count-skeleton {\n  display: inline-block;\n  width: 24px;\n  height: 8px;\n  border-radius: 4px;\n  background: currentColor;\n  opacity: 0.25;\n  animation: users-actions-pulse 1s ease-in-out infinite;\n}\n\n.users-actions-spinner {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  border: 2px solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: users-actions-spin 0.7s linear infinite;\n}\n\n@keyframes users-actions-spin {\n  to { transform: rotate(360deg); }\n}\n\n@keyframes users-actions-pulse {\n  50% { opacity: 0.1; }\n}\n\n:root[data-theme='dark'] .users-actions-dropdown {\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.45), 0 2px 6px rgba(0, 0, 0, 0.3);\n}\n\n:root[data-theme='dark'] .users-actions-audience.is-accent .users-actions-audience-icon {\n  color: #34d399;\n  background: rgba(52, 211, 153, 0.14);\n}\n\n@media (max-width: 640px) {\n  .users-actions-dropdown {\n    width: 290px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
